import { useState, useEffect } from "react";
import {
    Grid,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    IconButton,
    Tooltip,
    Paper,
    ListSubheader
} from "@mui/material";
import { AddCircleOutline, Delete, PropaneSharp } from "@mui/icons-material";
import { formatNumber } from "../ApiServices";

export default function ImpuestosEditar(props) {

    const handleInputChange = (index, field, value) => {
        props.propiedades.setDatosImpuestos((prevState) => {
            const updatedValues = prevState.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            );
            return updatedValues;
        });
    };

    const agregarLinea = () => {
        const nuevaLinea = {
            id_impuesto: null,
            // detalle: null,
            // porcentaje_alicuota: null,
            importe: null,
            uuid_comprobante: props.propiedades.datos.uuid_comprobante,
            usuario: localStorage.getItem("user"),
        };
        props.propiedades.setDatosImpuestos((prevState) => [...prevState, nuevaLinea]);
    };

    
    const handleDeshacerLinea = (index) => {
        const values = [...props.propiedades.datosImpuestos];

        // Eliminamos la línea seleccionada
        values.splice(index, 1);

        // Si después de borrar no queda nada (era la última línea),
        // insertamos una fila vacía para que los inputs sigan visibles.
        if (values.length === 0) {
            props.propiedades.setDatosImpuestos([
                {
                    id_impuesto: "",
                    importe: "",
                    uuid_comprobante: props.propiedades.datos.uuid_comprobante,
                    usuario: localStorage.getItem("user")
                }
            ]);
        } else {
            // Si todavía quedan otras líneas, simplemente actualizamos con el resto
            props.propiedades.setDatosImpuestos(values);
        }
    };


    console.log("datosImpuestos", props.propiedades.datosImpuestos);
    

    const style = {
        backgroundColor: "#ffffff",
        width: "100%",
        "& .MuiOutlinedInput-root": {
            "&:hover fieldset": {
                borderColor: "#1f618d",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#1f618d",
            },
        },
        "& .MuiInputLabel-root.Mui-focused": {
            color: "#1f618d",
        },
    };

    return (
        <div>
            <Paper
                elevation={3}
                sx={{
                    background: "linear-gradient(to right, #f8f9fa, #e8f0fe)",
                    mt: 1,
                    p: 3,
                    borderRadius: 4,
                    borderLeft: "6px solid #1f618d",
                }}
            >
                {props.propiedades.datosImpuestos && props.propiedades.datosImpuestos
                    .map((item, index, arrayFiltrado) => {
                        // IMPORTANTE: Definir indiceReal aquí adentro para usarlo abajo
                        const esElUltimoVisible = index === arrayFiltrado.length - 1;

                        return (
                            <Grid
                                container
                                spacing={2}
                                alignItems="center"
                                mt={0.5}
                                key={item.uuid_linea || `impuesto-${index}`}
                            >
                                <Grid item xs={12} sm={5}>
                                    <FormControl fullWidth focused size="small" sx={style}>
                                        <InputLabel>Impuestos</InputLabel>
                                        <Select
                                            label="Impuestos"
                                            value={item.id_impuesto || ""}
                                            onChange={(e) => handleInputChange(index, "id_impuesto", e.target.value)}
                                        >
                                            <ListSubheader sx={{ fontWeight: 'bold', color: '#1f618d', backgroundColor: '#f0f4f8' }}>
                                                Otros Impuestos
                                            </ListSubheader>
                                            {(props.propiedades.impuestos ?? [])
                                                .filter(e => ![29, 33, 34, 35, 36, 37].includes(e.idimpuestos))
                                                .map((elemento) => (
                                                    <MenuItem key={elemento.idimpuestos} value={elemento.idimpuestos}>
                                                        {elemento.descripcion}
                                                    </MenuItem>
                                                ))
                                            }
                                            <ListSubheader sx={{ fontWeight: 'bold', color: '#1f618d', backgroundColor: '#f0f4f8' }}>
                                                Impuestos Petroleras
                                            </ListSubheader>
                                            {(props.propiedades.impuestos ?? [])
                                                .filter(e => [29, 33, 34, 35, 36, 37].includes(e.idimpuestos))
                                                .map((elemento) => (
                                                    <MenuItem key={elemento.idimpuestos} value={elemento.idimpuestos}>
                                                        {elemento.descripcion}
                                                    </MenuItem>
                                                ))
                                            }
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <TextField
                                        fullWidth
                                        focused
                                        style={style}
                                        required={item.id_impuesto !== null}
                                        onChange={(e) => handleInputChange(index, "importe", e.target.value)}
                                        size="small"
                                        label="Importe"
                                        value={
                                            item.importe !== undefined && item.importe !== null
                                                ? (typeof item.importe === 'number'
                                                    ? formatNumber(item.importe.toFixed(2).replace(".", ","))
                                                    : formatNumber(item.importe))
                                                : ""
                                        }
                                        onBlur={(e) => handleInputChange(index, "importe", formatNumber(e.target.value))}
                                        onKeyPress={(event) => {
                                            const { value } = event.target;
                                            if (!/[\d,]/.test(event.key)) event.preventDefault();
                                            if (event.key === "," && value.includes(",")) event.preventDefault();
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={3} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                                    <Tooltip title="Eliminar línea">
                                        <IconButton
                                            onClick={() => handleDeshacerLinea(index)}
                                            sx={{ color: "#e74c3c" }}
                                        >
                                            <Delete />
                                        </IconButton>
                                    </Tooltip>

                                    <Tooltip title="Agregar línea">
                                        <span>
                                            <IconButton
                                                color="primary"
                                                onClick={agregarLinea}
                                                // Si es la primera línea y está vacía, permitimos el click para que no se trabe
                                                disabled={!esElUltimoVisible || (item.id_impuesto && (!item.importe || item.importe === "0,00"))}
                                                sx={{
                                                    color: "#1f618d",
                                                    visibility: esElUltimoVisible ? "visible" : "hidden",
                                                }}
                                            >
                                                <AddCircleOutline />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Grid>
                            </Grid>
                        );
                    })
                }
            </Paper>
        </div>
    )
}